// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"ti_a bii_rc bii_qx bii_xr","ForumPosts__contest":"ti_b bii_hq","ForumPosts__counselling":"ti_c"};